// Date localization, only import the supported locales we need.
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import 'dayjs/locale/en';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import updateLocale from 'dayjs/plugin/updateLocale';
import utc from 'dayjs/plugin/utc';

import { store } from 'LEGACY/reactTreeMounting';

dayjs.extend(localizedFormat);
dayjs.extend(updateLocale);
dayjs.extend(utc);

dayjs.updateLocale('fr', {
  calendar: {
    lastDay: '[Hier à] LT',
    sameDay: '[Aujourd’hui à] LT',
    nextDay: '[Demain à] LT',
    lastWeek: 'dddd [dernier à] LT',
    nextWeek: 'dddd [à] LT',
    sameElse: 'L',
  },
});

const _ = (key) => {
  const locale = store?.getState().user.locale || window.userLocale;
  if (window.cloudI18n[locale][key]) {
    return window.cloudI18n[locale][key];
  } else {
    return key;
  }
};

const localize = (label) => {
  const locale = store?.getState().user.locale || window.userLocale;
  if (typeof label === 'string') {
    return label;
  } else if (label[locale]) {
    return label[locale];
  } else {
    return label.en;
  }
};

export default {
  _,
  localize,
};
